export default "__VITE_ASSET__BwKZbd33__"